<table class="tabela-preco" [hidden]="outrosPrecosDisponivel()">
  <thead>
    <tr>
      <th>Qtd. Mínima</th>
      <th>Un. Medida</th>
      <th>Preço liquido</th>
      <th>Preço + IPI + ICMSST</th>
      <th></th>
      <th>
        @if (!dialogParent) {
        <mat-icon (click)="closeDialog()">close</mat-icon>
        }
      </th>
    </tr>
  </thead>
  <tbody>
    @for (tabelaPreco of tabelasDePreco; track $index) {
    <tr (click)="getTabelaPrecoEmitter(tabelaPreco);" [ngClass]="{'tabela-selecionada': tabelaPreco.idGeral === tabelaSelecionada}">
      <td>{{tabelaPreco.qtMinima}}</td>
      <td>{{tabelaPreco.unMedida}}</td>
      <td>{{tabelaPreco.precoLiquido.toFixed(2) | currency:'BRL'}}</td>
      <td>{{tabelaPreco.precoLiquidoComIpiIcmsSubstituicao.toFixed(2) | currency:'BRL'}}</td>
      @if (tabelaPreco.flPromocao) {
      <td><mat-icon style="transform: translateY(4px); cursor: default;">discount</mat-icon></td>
      } @else {
      <td></td>
      }
      @if (tabelaPreco.idGeral === tabelaSelecionada) {
      <td>
        <mat-icon style="cursor: default;" [ngClass]="{'mat-icon-select': tabelaPreco.idGeral === tabelaSelecionada}">check_circle</mat-icon>
      </td>
      } @else {
      <td></td>
      }
    </tr>
    }
  </tbody>
</table>
